import { ClipboardList, HeartPulse, Pill, Users } from 'lucide-react';
import OnboardingSlide from './OnboardingSlide';
import RecordingDemoAnimation from './RecordingDemoAnimation';

const NOTE_TYPES = [
  { label: 'Progress', icon: ClipboardList, className: 'bg-primary' },
  { label: 'Vitals', icon: HeartPulse, className: 'bg-vitals' },
  { label: 'MAR', icon: Pill, className: 'bg-mar' },
  { label: 'Handover', icon: ClipboardList, className: 'bg-handover' },
];

export default function SlideRecording() {
  return (
    <OnboardingSlide illustration={<RecordingDemoAnimation />} title="Document by Voice">
      <p className="inline-flex items-center gap-1 rounded-full bg-primary-light px-2.5 py-1 text-[11px] font-semibold text-primary sm:text-xs">
        <Users className="h-3 w-3 shrink-0" />
        Multi-patient detection
      </p>
      <p>
        Tap and <strong>hold the blue microphone button</strong> at the bottom of the screen. Speak
        while holding — release when done. You will see a <strong>live transcript</strong> as you talk.
      </p>
      <p className="font-medium text-gray-700">Supported note types (auto-detected):</p>
      <div className="flex flex-wrap gap-1.5">
        {NOTE_TYPES.map(({ label, icon: Icon, className }) => (
          <span
            key={label}
            className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold text-white ${className}`}
          >
            <Icon className="h-2.5 w-2.5" />
            {label}
          </span>
        ))}
      </div>
      <p className="font-medium text-gray-700">Example of what to say to record vitals for two patients:</p>
      <div className="rounded-xl border border-primary bg-primary-light p-2.5 text-xs" dir="rtl">
        غرفة 3 ليلى يوسف، ألم 4 من 10، أعيد التقييم بعد ساعتين. غرفة 21 نور الدين، ضغط 95 على
        60، نبض 88.
      </div>
      <p className="font-medium text-gray-700">Tips:</p>
      <ul className="list-inside list-disc space-y-0.5 text-xs">
        <li>Always say <strong>patient name or room</strong> first.</li>
        <li>Speak Arabic, English, or both — Sawtna understands clinical speech.</li>
        <li>Say numbers clearly.</li>
        <li>
          You can document <strong>multiple patients</strong> in one recording — mention each name or room
          when you switch.
        </li>
        <li>Record in a quiet spot and keep the mic uncovered.</li>
      </ul>
    </OnboardingSlide>
  );
}
